import { useRef, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Container, Row, Col } from 'react-bootstrap'
import Alert from '../Alert/Alert'
import useAuth from '../../hooks/useAuth'
import Spinner from '../Spinner/Spinner'

const Login = () => {
	const history = useHistory()

	const { fetchUser, alert, loading } = useAuth()

	const emailRef = useRef()
	const passRef = useRef()

	const handleLogin = (e) => {
		e.preventDefault()
		const user = {
			email: emailRef.current.value,
			password: passRef.current.value,
		}

		fetchUser(user)
	}

	useEffect(() => {
		const savedUser = localStorage.getItem('user')
		const savedUserObj = JSON.parse(savedUser)

		if (savedUserObj?._id) {
			history.push('/dashboard')
		}
	}, [handleLogin])

	return (
		<section className='login-section'>
			<Container className='h-100'>
				<Row className='justify-content-center align-items-center h-100'>
					<Col md={5}>
						<div className='login-form'>
							{loading ? (
								<Spinner />
							) : (
								alert && <Alert msg={alert} />
							)}
							<h4 className='mb-4'>Login</h4>
							<form onSubmit={handleLogin}>
								<div className='form-group mb-3'>
									<input
										ref={emailRef}
										type='text'
										className='form-control'
										placeholder='Email'
									/>
								</div>
								<div className='form-group mb-3'>
									<input
										ref={passRef}
										type='password'
										className='form-control'
										placeholder='Password'
									/>
								</div>
								<div className='form-group'>
									<input
										className='btn btn-primary'
										type='submit'
										value='Sign In'
									/>
								</div>
							</form>
						</div>
					</Col>
				</Row>
			</Container>
		</section>
	)
}

export default Login
